import { inject, provideAppInitializer } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const provideAuthInitializer = () =>
  provideAppInitializer(async () => {
    const authService = inject(AuthService);
    await firstValueFrom(authService.bootstrapAuth());
  });